import { render, staticRenderFns } from "./PreferencesTabs.vue?vue&type=template&id=cfb6e1d6&"
import script from "./PreferencesTabs.vue?vue&type=script&lang=js&"
export * from "./PreferencesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports